import React from 'react';
import './Faq.scss';
import Question from '../../components/faq-components/Question';
import questionData from './questionData';
import {Helmet, HelmetProvider } from 'react-helmet-async';
import OgImage from '../../assets/img/Og.png';

function Faq({t}) {
    const questionItem = questionData(t).map((item) => (
        <Question data={item}/>
    ))
  return (
    <HelmetProvider>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{t("faq_og_title")}</title>
        <meta name="description" content={t("faq_og_description")}></meta>
        <meta property="og:title" content={t("faq_og_title")} />
        <meta property="og:description" content={t("faq_og_description")} />
        <meta property="og:image" content={OgImage} />
        <link rel="canonical" href="https://weexpert.io/" />
      </Helmet>
    <div className="faq-wrapper">
        <div className="faq-content-wrapper">
            <div className="faq-capture">
                 {t("faq_capture")}
            </div>
                {questionItem}
        </div>
    </div>
    </HelmetProvider>
  );
}

export default Faq;